<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>堆雪球管理</el-breadcrumb-item>
      <el-breadcrumb-item>好友列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">好友列表</span>
      </div>

      <!-- 查询条件 -->
      <el-form :inline="true" label-width="100px" size="small" style="margin-bottom: 20px;">
        <el-form-item label="通过时间：">
          <el-date-picker
            v-model="form.passTimeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 350px;">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="活跃时间：">
          <el-date-picker
            v-model="form.lastActiveRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 350px;">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="微信账号：">
          <el-select v-model="form.wechatAccountId" placeholder="请选择微信账号" clearable style="width: 200px;">
            <el-option
              v-for="item in weixinList"
              :key="item.id"
              :label="item.nickname"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="关键词：">
          <el-input v-model="form.keyword" placeholder="昵称/备注/微信号/别名" clearable style="width: 200px;"></el-input>
        </el-form-item>

        <el-form-item label="每页数量：">
          <el-input-number v-model="form.pageSize" :min="1" :max="200" style="width: 120px;"></el-input-number>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getFriendList" :loading="loading">查询</el-button>
          <el-button @click="resetFilters" style="margin-left: 10px;">重置</el-button>
          <el-button @click="distinctConRemark" :loading="distinctConRemarkLoading" style="margin-left: 10px;">去重</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格区域 -->
      <div v-if="list.length > 0">
        <el-table :data="list" border style="width: 100%">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="avatar" label="好友头像" width="70">
            <template slot-scope="scope">
              <el-image :src="scope.row.avatar" fit="fill" :preview-src-list="[scope.row.avatar]" style="width: 50px; height: 50px;"></el-image>
            </template>
          </el-table-column>
          <el-table-column label="好友信息" width="240">
            <template slot-scope="scope">
              <div style="font-size: 12px;">
                <div>昵称：{{ scope.row.nickname }}</div>
                <div>微信号：{{ scope.row.alias }}</div>
                <div>微信Id：{{ scope.row.wechatId }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="性别" width="50">
            <template slot-scope="scope">
              {{ scope.row.gender === 1 ? '男' : scope.row.gender === 2 ? '女' : '未知' }}
            </template>
          </el-table-column>
          <el-table-column prop="avatar" label="所属人头像" width="70">
            <template slot-scope="scope">
              <el-image :src="scope.row.ownerAvatar" fit="fill" :preview-src-list="[scope.row.ownerAvatar]" style="width: 50px; height: 50px;"></el-image>
            </template>
          </el-table-column>
          <el-table-column label="所属人" width="240">
            <template slot-scope="scope">
              <div style="font-size: 12px;">
                <div>昵称：{{ scope.row.ownerNickname }}</div>
                <div>微信号：{{ scope.row.ownerAlias }}</div>
                <div>微信Id：{{ scope.row.ownerWechatId }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="id信息" width="340">
            <template slot-scope="scope">
              <div style="font-size: 12px;">
                <div>所属人：{{ scope.row.wechatAccountId }}</div>
                <div>好友：{{ scope.row.id }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="时间信息" width="180">
            <template slot-scope="scope">
              <div style="font-size: 12px;">
                <div v-if="scope.row.passTime">
                  <span style="color: #409EFF;">通过: </span>
                  {{ scope.row.passTime|dateFormat }}
                </div>
                <div v-if="scope.row.lastActivityTime" style="margin-top: 5px;">
                  <span style="color: #67C23A;">活跃: </span>
                  {{ scope.row.lastActivityTime|dateFormat }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="conRemark" label="备注" width="180">
            <template slot-scope="scope">
              <div style="font-size: 12px;">
                {{ scope.row.conRemark || '' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="备注分析" width="120">
            <template slot-scope="scope">
              <div style="font-size: 10px;">
                <div>类型：{{ scope.row.type === 'A' ? '成交' : scope.row.type === 'B' ? '意向' : scope.row.type === 'C' ? '潜在' : scope.row.type === 'D' ? '无效' : scope.row.type }}</div>
                <div>城市：{{ scope.row.city }}</div>
                <div>来源：{{ scope.row.from }}</div>
                <div>品牌：{{ scope.row.brand }}</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px; text-align: center;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="form.pageIndex + 1"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="form.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <div v-else class="no-data">
        <el-empty description="暂无数据，请设置查询条件后获取列表"></el-empty>
      </div>
    </el-card>

    <!-- 去重结果对话框 -->
    <el-dialog
      title="备注去重结果"
      :visible.sync="showConRemarkDialog"
      width="60%"
      :close-on-click-modal="false">
      <div v-if="conRemarkList.length > 0">
        <p style="margin-bottom: 15px; color: #409EFF;">
          <i class="el-icon-info"></i>
          共找到 <strong>{{ conRemarkList.length }}</strong> 个不重复的备注值：
        </p>
        <div style="max-height: 400px; overflow-y: auto; border: 1px solid #EBEEF5; border-radius: 4px; padding: 10px;">
          <el-tag
            v-for="(remark, index) in conRemarkList"
            :key="index"
            :type="remark === '' ? 'info' : 'primary'"
            style="margin: 3px 5px 3px 0;"
            size="small">
            {{ remark === '' ? '(空备注)' : remark }}
          </el-tag>
        </div>
      </div>
      <div v-else style="text-align: center; padding: 20px;">
        <el-empty description="没有找到任何备注数据"></el-empty>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showConRemarkDialog = false">关闭</el-button>
        <el-button type="primary" @click="copyConRemarkList">复制列表</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'DuixueqiuFriendList',
  data () {
    return {
      loading: false,
      list: [],
      total: 0,
      form: {
        passTimeRange: null,
        lastActiveRange: null,
        wechatAccountId: '',
        keyword: '',
        pageIndex: 0,
        pageSize: 20
      },
      weixinList: [],
      distinctConRemarkLoading: false,
      conRemarkList: [],
      showConRemarkDialog: false

    }
  },
  created () {
    this.getWeixinList()
    this.getFriendList()
  },
  methods: {
    // 获取微信账号列表（本地数据库）
    async getWeixinList () {
      try {
        const { data: res } = await this.$http.get('duixueqiu/weixinList', {
          params: { pageIndex: 0, pageSize: 200 }
        })
        if (res.meta.status === 200) {
          this.weixinList = (res.data.list || res.data || [])
        }
      } catch (e) {
        // 静默处理，不影响好友列表查询
      }
    },

    // 查询好友列表（本地数据库）
    async getFriendList () {
      this.loading = true
      try {
        const params = {
          pageIndex: this.form.pageIndex,
          pageSize: this.form.pageSize,
          passTimeFrom: this.form.passTimeRange && this.form.passTimeRange[0] ? this.form.passTimeRange[0] : undefined,
          passTimeTo: this.form.passTimeRange && this.form.passTimeRange[1] ? this.form.passTimeRange[1] : undefined,
          lastActiveFrom: this.form.lastActiveRange && this.form.lastActiveRange[0] ? this.form.lastActiveRange[0] : undefined,
          lastActiveTo: this.form.lastActiveRange && this.form.lastActiveRange[1] ? this.form.lastActiveRange[1] : undefined,
          wechatAccountId: this.form.wechatAccountId || undefined,
          keyword: this.form.keyword || undefined
        }

        const { data: res } = await this.$http.get('duixueqiu/friendList', { params })
        if (res.meta.status === 200) {
          const data = res.data || {}
          // 文档返回格式为 { list, total, pageIndex, pageSize, totalPages }
          // 兼容服务可能返回 { results, total }
          this.list = data.list || data.results || []
          this.total = data.total || 0
          this.$message.success('获取好友列表成功')
        } else {
          this.$message.error(res.meta.msg || '获取好友列表失败')
        }
      } catch (error) {
        this.$message.error('获取好友列表失败：' + error.message)
      } finally {
        this.loading = false
      }
    },

    // 对conRemark字段去重
    async distinctConRemark () {
      this.distinctConRemarkLoading = true
      try {
        const { data: res } = await this.$http.post('duixueqiu/distinctConRemark', {
          passTimeFrom: this.form.passTimeRange && this.form.passTimeRange[0] ? this.form.passTimeRange[0] : undefined,
          passTimeTo: this.form.passTimeRange && this.form.passTimeRange[1] ? this.form.passTimeRange[1] : undefined,
          lastActiveFrom: this.form.lastActiveRange && this.form.lastActiveRange[0] ? this.form.lastActiveRange[0] : undefined,
          lastActiveTo: this.form.lastActiveRange && this.form.lastActiveRange[1] ? this.form.lastActiveRange[1] : undefined,
          wechatAccountId: this.form.wechatAccountId || undefined,
          keyword: this.form.keyword || undefined
        })
        if (res.meta.status === 200) {
          this.conRemarkList = res.data || []
          this.showConRemarkDialog = true
          this.$message.success(`获取去重结果成功，共找到 ${this.conRemarkList.length} 个不重复的备注值`)
        } else {
          this.$message.error(res.meta.msg || '获取去重结果失败')
        }
      } catch (error) {
        this.$message.error('获取去重结果失败：' + error.message)
      } finally {
        this.distinctConRemarkLoading = false
      }
    },

    // 复制备注列表到剪贴板
    copyConRemarkList () {
      if (this.conRemarkList.length === 0) {
        this.$message.warning('没有数据可复制')
        return
      }

      const text = this.conRemarkList.map(remark => remark === '' ? '(空备注)' : remark).join('\n')

      // 使用现代浏览器的 Clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('备注列表已复制到剪贴板')
        }).catch(() => {
          this.fallbackCopyTextToClipboard(text)
        })
      } else {
        this.fallbackCopyTextToClipboard(text)
      }
    },

    // 兼容旧浏览器的复制方法
    fallbackCopyTextToClipboard (text) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$message.success('备注列表已复制到剪贴板')
        } else {
          this.$message.error('复制失败，请手动复制')
        }
      } catch (err) {
        this.$message.error('复制失败，请手动复制')
      }

      document.body.removeChild(textArea)
    },

    // 重置筛选条件
    resetFilters () {
      this.form.passTimeRange = null
      this.form.lastActiveRange = null
      this.form.wechatAccountId = ''
      this.form.keyword = ''
      this.form.pageIndex = 0
      this.form.pageSize = 20
      this.getFriendList()
    },

    // 分页事件处理
    handleSizeChange (val) {
      this.form.pageSize = val
      this.form.pageIndex = 0
      this.getFriendList()
    },

    handleCurrentChange (val) {
      this.form.pageIndex = val - 1
      this.getFriendList()
    },

    // 友好显示日期
    formatDate (val) {
      if (!val) return '-'
      try {
        const d = new Date(val)
        if (isNaN(d.getTime())) return val
        const y = d.getFullYear()
        const m = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        const hh = String(d.getHours()).padStart(2, '0')
        const mm = String(d.getMinutes()).padStart(2, '0')
        const ss = String(d.getSeconds()).padStart(2, '0')
        return `${y}-${m}-${day} ${hh}:${mm}:${ss}`
      } catch (e) {
        return val
      }
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.flexContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cardHeader {
  font-size: 24px;
  font-weight: bold;
}

.no-data {
  text-align: center;
  padding: 20px;
}
</style>
